
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Box, useTheme, Button, InputBase, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ModalEditWors from "../../modal/garden/modalEditWork";
import { getResumenView, getMarcacionesView, } from "../../services/marcaciones.services";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import ModalCharge from "../../modal/modalCharge";
import CustomToolbar from "../../utils/CustomToolbar";
import ExcelJS from 'exceljs';
import ModalHorasExtras from "../../modal/horasExtras/ModalHorasExtrasRe";
import { getHorasExtrasView } from "../../services/horasExtras.services";
import { getFaltas } from "../../services/faltas.services";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import DescuentosModal from "../../modal/descuento/modalDescuento";
import { getDatosUserView } from "../../services/user.services";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

import { getBancoPendiente } from "../../services/banco.services";
import ModalBancoHoras from "../../modal/modalBancoHoras";

const Resumen = () => {
  const [datahe, setDatahe] = useState([]);
  const [modalEditWorks, setModalEditWorks] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedWorks, setSelectedWorks] = useState(null);
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [originalData, setOriginalData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalHorasExtras, setModalHorasExtras] = useState(false);
  const [resumenHorasExtras, setResumenHorasExtras] = useState(null);
  const [modalBancoHoras, setModalBancoHoras] = useState(false);
  const [resumenBancoHoras, setResumenBancoHoras] = useState(null);
  const [datosBanco, setDatosBanco] = useState([]);
  const [rowSettings, setRowSettings] = useState({});
  const [empresaLogoCode, setEmpresaLogoCode] = useState(1);
  const [marcacionesData, setMarcacionesData] = useState([]);
  const [faltasData, setFaltasData] = useState([]);
  const [dateError, setDateError] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [empresaActiva, setEmpresaActiva] = useState("GENERAL");
  const [openDescuentos, setOpenDescuentos] = useState(false);
  const [descuentosSeleccionados, setDescuentosSeleccionados] = useState([]);
  const [funcionarioSeleccionado, setFuncionarioSeleccionado] = useState(null);
  const [marcacionesFiltradas, setMarcacionesFiltradas] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [grupoActivo, setGrupoActivo] = useState("TODOS");
  const [turnoActivo, setTurnoActivo] = useState("TODOS");
  const [turnos, setTurnos] = useState([]);




  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [

    { field: "id_usuario", headerName: "ID_USUARIO", flex: 0.5, },
    { field: "Id_empleado", headerName: "ID_EMPLEADO", flex: 0.5, },

    {
      field: "nombre",
      headerName: "NOMBRE",
      flex: 1,
      cellClassName: "name-column--cell",
    },

    {
      field: "grupo",
      headerName: "GRUPO",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "horas",
      headerName: "HORAS TRABAJADAS",
      flex: 0.5,
      renderCell: (params) => {
        const minutos = params.value ? convertToMinutes(params.value) : 0;
        const totalHoras = convertToTimeFormat(minutos);
        return totalHoras;
      },
    },
    {
      field: "dias_trabajados",
      headerName: "Días Trabajados",
      flex: 0.5,
      type: "number",
      cellClassName: "name-column--cell",
    },
    {
      field: "salario_base",
      headerName: "Salario Base",
      flex: 0.7,
      type: "number",
      valueFormatter: ({ value }) => value.toLocaleString('es-PY', { style: 'currency', currency: 'PYG' }),
    },
    {
      field: "salario",
      headerName: "Salario",
      flex: 0.7,
      type: "number",
      valueFormatter: ({ value }) => value.toLocaleString('es-PY', { style: 'currency', currency: 'PYG' }),
    },
    {
      field: "salario_ips",
      headerName: "Salario IPS",
      flex: 0.7,
      type: "number",
      valueFormatter: ({ value }) =>
        value.toLocaleString("es-PY", { style: "currency", currency: "PYG" }),
    },
    {
      field: "nocturno",
      headerName: "A.Nocturno",
      flex: 0.5,
      type: "number",
      cellClassName: "name-column--cell",
    },
    {
      field: "bono_familiar",
      headerName: "Bono Familiar",
      flex: 0.7,
      type: "number",
      valueFormatter: ({ value }) => value.toLocaleString('es-ES', { minimumFractionDigits: 2 }),
    }, 
    {
      field: "bono_produccion",
      headerName: "Bono Producción",
      flex: 0.7,
      type: "number",
      valueFormatter: ({ value }) => value.toLocaleString('es-ES', { minimumFractionDigits: 2 }),
    },

    {
  field: "overtime_work_price",
  headerName: "Horas Extras",
  flex: 0.7,
  type: "number",
  renderCell: (params) => (
    <Button
      variant="text"
      color="success"
      onClick={() => handleOpenHorasExtras(params)}
      sx={{ textTransform: "none" }}
    >
      {params.value?.toLocaleString("es-ES", { minimumFractionDigits: 2 })}
    </Button>
  ),
},

    {
      field: "banco",
      headerName: "Banco de Horas",
      flex: 0.5,
      type: "number",
      renderCell: (params) => (
        <Button
          variant="text"
          color="success"
          onClick={() => handleOpenBancoHoras(params)}
          sx={{ textTransform: "none" }}
        >
          {convertToTimeFormat(Number(params.value || 0))}
        </Button>
      ),
    },
    {
      field: "ips",
      headerName: "IPS",
      flex: 0.5,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "adelanto_deduction",
      headerName: "Adelanto",
      flex: 0.7,
      type: "number",
      valueFormatter: ({ value }) => value.toLocaleString('es-PY', { style: 'currency', currency: 'PYG' }),
    },
    {
      field: "descuento",
      headerName: "Descuento",
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="text"          // sin fondo por defecto
          size="small"
          onClick={() => handleOpenModal(params.row)}
          sx={{
            color: "#D00000",
            fontWeight: "Bold",
            fontSize: "0.875rem",      // 🔹 mismo tamaño que DataGrid por defecto
            textTransform: "none",     // 🔹 evita que se convierta a mayúsculas
            minWidth: "100%",          // 🔹 ocupa el ancho de la celda como los demás
            justifyContent: "center", // 🔹 alinea como texto normal
            minWidth: "auto",     // botón pequeño, ajustado al texto
            padding: "2px 6px",   // menos padding
            "&:hover": {
              backgroundColor: "rgba(208,0,0,0.1)", // rojo claro al hover
            },
          }}
        >
          {params.value.toLocaleString("es-PY")}
        </Button>
      ),
    },
    {
      field: "total",
      headerName: "TOTAL A PAGAR",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "total_banco",
      headerName: "TOTAL BANCO",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "total_adicional",
      headerName: "TOTAL ADICIONAL",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
  ];

    const handleOpenModal = (row) => {
  const inicio = dayjs(startDate).format("YYYY-MM-DD");
  const fin = dayjs(endDate).format("YYYY-MM-DD");

  // 🔹 Llegadas tardías (marcaciones)
  const llegadasTardias = marcacionesFiltradas
    .filter(m =>
      m.id_usuario === row.id_usuario &&
      Number(m.descuento) > 0 &&
      dayjs(m.entrada).format("YYYY-MM-DD") >= inicio &&
      dayjs(m.entrada).format("YYYY-MM-DD") <= fin
    )
    .map(m => ({
      tipo: "LLEGADA_TARDIA",
      fecha: m.entrada,
      descripcion: "Llegada tardía",
      monto: Number(m.descuento),
    }));

  // 🔹 Permisos por hora
  const permisosPorHora = faltasData
    .filter(f =>
      f.id_usuario === row.id_usuario &&
      f.tipo === "PERMISO_POR_HORA" &&
      dayjs(f.hora_inicio).format("YYYY-MM-DD") >= inicio &&
      dayjs(f.hora_inicio).format("YYYY-MM-DD") <= fin
    )
    .map(f => ({
      tipo: "PERMISO_POR_HORA",
      fecha: f.hora_inicio,
      hora_fin: f.hora_fin,
      descripcion: "Permiso por hora",
      monto: Number(f.descuento),
    }));

  // 🔹 Otros descuentos
  const otrosDescuentos = faltasData
    .filter(f =>
      f.id_usuario === row.id_usuario &&
      f.tipo === "DESCONTAR" &&
      dayjs(f.fecha_inicio).format("YYYY-MM-DD") >= inicio &&
      dayjs(f.fecha_inicio).format("YYYY-MM-DD") <= fin
    )
    .map(f => ({
      tipo: "DESCONTAR",
      fecha: f.fecha_inicio,
      descripcion: f.descripcion || "Otros descuentos",
      monto: Number(f.descuento),
    }));

  const descuentos = [
    ...llegadasTardias,
    ...permisosPorHora,
    ...otrosDescuentos,
  ];

  setFuncionarioSeleccionado(row);
  setDescuentosSeleccionados(descuentos);
  setOpenDescuentos(true);
};

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await getHorasExtrasView(
            startDate.format("YYYY-MM-DD"),
            endDate.format("YYYY-MM-DD")
          );
          setDatahe(response);
  
          const initialSettings = {};
          response.forEach((row) => {
            initialSettings[row.id_marcacion] = {
              enabled: row.aprobación_horas_extras === 1,
            };
          });
          setRowSettings(initialSettings);
        } catch (error) {
          console.error("Error al obtener datos del backend:", error);
          setSnackbarMessage("Error al cargar los datos.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      };
  
      fetchData();
    }, [startDate, endDate]);

const calcularDiasTrabajados = ({
  fechaIngreso,
  fechaEgreso,
  startDate,      // inicio del periodo (ej: 2023-10-01)
  endDate,        // fin del periodo (ej: 2023-10-13)
  faltas,
  id_usuario,
}) => {
  // 🔹 Ajustar fin real si hay egreso
    let endReal = endDate;

    if (fechaEgreso) {
      const egreso = dayjs(fechaEgreso).endOf("day");
      endReal = egreso.isBefore(endDate) ? egreso : endDate;
    }

  const ingreso = dayjs(fechaIngreso).startOf("day");
  
  // 1. 🔹 Calcular cuántos días reales tiene el rango seleccionado
  // Si es del 1 al 13, esto dará 13.
  const diasRango = endReal.diff(startDate, 'day') + 1;

  // 2. 🔹 Determinar el tope (diasBase)
  // Si el rango es el mes completo, usamos 30. Si es un filtro parcial, usamos los días del rango.
  let diasBase = (diasRango >= 28 && startDate.date() === 1) ? 30 : diasRango;

  // Excepción: febrero completo (para que no de 30 si es 28)
  const mes = startDate.month() + 1;
  const año = startDate.year();
  if (mes === 2 && diasRango >= 28) {
    diasBase = dayjs(`${año}-02-01`).daysInMonth();
  }

  let diasFinales = diasBase;

  // 3. 🔹 Ajuste por fecha de ingreso
  if (fechaIngreso) {
    const inicioMes = startDate.startOf("day");
    // Si ingresó DESPUÉS del inicio del filtro actual
    if (ingreso.isAfter(inicioMes)) {
      const diasNoTrabajadosAntesDeIngreso = ingreso.diff(inicioMes, 'day');
      diasFinales = Math.max(0, diasFinales - diasNoTrabajadosAntesDeIngreso);
    }
  }

  // 4. 🔻 Descontar faltas (solo las que caen dentro del rango startDate - endDate)
  const faltasPorDia = faltas
    .filter(f =>
      f.id_usuario === id_usuario &&
      (f.tipo === "AUSENCIA" || f.tipo === "PERMISO_POR_DIA") &&
      dayjs(f.fecha_inicio).isSameOrAfter(startDate, "day") &&
      dayjs(f.fecha_fin).isSameOrBefore(endDate, "day")
    )
    .reduce((acc, f) => acc + (Number(f.dias) || 1), 0);

  diasFinales -= faltasPorDia;

  // 🔐 Reglas finales correctas

    // Nunca negativos
    diasFinales = Math.max(diasFinales, 0);

    // 🟢 Caso especial: ingreso el 30 o 31 → siempre 1 día
    if (
      fechaIngreso &&
      ingreso.isSameOrBefore(endDate) &&
      ingreso.date() >= 30 &&
      diasFinales === 0
    ) {
      diasFinales = 1;
  }

  
  return diasFinales;
};

function tablaPivote(data, mes, año) {
  const diasDelMes = new Date(año, mes, 0).getDate();
  const empleados = {};

  data.forEach((item) => {
    const entrada = new Date(item.entrada);
    const dia = entrada.getDate();
    const id = item.Id_empleado;

    const esDomingo = entrada.getDay() === 0;
    if (esDomingo) return;

    if (!empleados[id]) {
      empleados[id] = {
        id_empleado: id,
        nombre: item.funcionario,
        dias: Array(diasDelMes).fill(0),
      };
    }

    empleados[id].dias[dia - 1] = Number(item.adicional_nocturno);
  });

  const empleadosProcesados = Object.values(empleados).map((emp) => {
    const diasTrabajados = emp.dias.filter((m) => m > 0);

    const total = diasTrabajados.reduce((sum, m) => sum + m, 0);

    return { ...emp, total };
  });

  return empleadosProcesados;
}

  useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const handleRowSelection = (newSelection) => {
    if (newSelection.length === 0) {
      setSelectedWorks(null);
      setSelectedRowIds([]);
      setActiveButton(false);
    } else {
      const selectedRowId = newSelection[newSelection.length - 1];
      setSelectedRowIds([selectedRowId]);
      const selectedRow = data.find((row) => row.Id === selectedRowId);
      setSelectedWorks(selectedRow.Id);
      setActiveButton(true);
    }
  };


  const handleSwitchChange = (id_marcacion) => {
    return async (event) => {
  const isChecked = event.target.checked;
  const newApproval = isChecked ? 1 : 0;

  // Buscar la fila correspondiente
  const row = filteredData.find((r) => r.id_marcacion === id_marcacion);
  

  let montoCalculado = 0;

  if (isChecked) {
    // Obtener el desglose de horas extras
    const desglose = columns.find(col => col.field === "desglose_horas")
                            .valueGetter({ row: row });
    
    // Calcular el monto total en base a horas (no minutos)
    const salarioMensual = Number(row.salario_monto);
    const salarioPorHora = salarioMensual / (30 * 8); // Salario diario / 8 horas

    let montoTotal = 0;

    if (desglose.desglose.domingo) {
      // Domingos (+100%)
      montoTotal += (salarioPorHora * 2) * desglose.desglose.domingo;
    } else {
      if (desglose.desglose.diurnas) {
        // Horas diurnas (+50%)
        montoTotal += (salarioPorHora * 1.5) * desglose.desglose.diurnas;
      }
      if (desglose.desglose.nocturnas) {
        // Horas nocturnas (+160%)
        montoTotal += (salarioPorHora * 2.6) * desglose.desglose.nocturnas;
      }
    }

    montoCalculado = Math.round(montoTotal);
  }

  try {
    // Guardar el monto calculado en la base de datos
    await saveOvertimeActivation(id_marcacion, montoCalculado, newApproval);

    // Actualizar el estado del switch
    setRowSettings((prev) => ({
      ...prev,
      [id_marcacion]: { enabled: isChecked },
    }));

    // Actualizar el valor mostrado en la grilla
    setFilteredData((prev) =>
      prev.map((row) =>
        row.id_marcacion === id_marcacion
          ? {
              ...row,
              descripcion_horas_extras: isChecked ? `${montoCalculado} Gs` : "",
            }
          : row
      )
    );

    setSnackbarMessage(
      isChecked
        ? "Agregado exitosamente al pago"
        : "Removido exitosamente del pago"
    );
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  } catch (error) {
    console.error("Error updating overtime approval:", error);
    setSnackbarMessage("Error al actualizar la aprobación");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }
};
  };


// const handleOpenHorasExtras = (params) => {
//   const empleado = params.row;

//   // Filtrar las horas extras del empleado seleccionado
//   const detalleEmpleado = datahe.filter(
//     (item) => item.id_usuario === empleado.id_usuario
//   );
const handleOpenBancoHoras = (params) => {
  const empleado = params.row;

  const detalleBanco = datosBanco.filter(
    (item) => item.id_empleado === empleado.Id_empleado || item.id_usuario === empleado.id_usuario
  );

  const resumen = {
    nombre: empleado.nombre || "Sin nombre",
    grupo: empleado.grupo || "Sin grupo",
    detalle: detalleBanco.map((item, index) => {
      const fecha = new Date(item.deber_fecha || item.debe_fecha || item.created_at);
      const fechaFormateada = fecha.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      const minutosValor = Number(item.minutos || 0);
      const horasEnteras = Math.floor(minutosValor / 60);
      const minutosRestantes = Math.round(minutosValor % 60);
      const horasTexto = `${horasEnteras}:${minutosRestantes.toString().padStart(2, "0")}`;

      const estado = item.pagar_fecha ? "Aplicado" : (item.status_active === 1 ? "Pendiente" : "Inactivo");

      return {
        id: item.id ?? index,
        fecha: fechaFormateada,
        horas_h: Number((minutosValor / 60).toFixed(2)),
        minutos: minutosValor,
        horas_texto: horasTexto,
        estado,
      };
    }),
  };

  setResumenBancoHoras(resumen);
  setModalBancoHoras(true);
};

const handleOpenHorasExtras = (params) => {
  const empleado = params.row;

  const detalleEmpleado = datahe.filter(
    (item) => item.id_usuario === empleado.id_usuario
  );

  const resumen = {
    nombre: empleado.nombre || "Sin nombre",
    grupo: empleado.grupo || "Sin grupo",
    detalle: detalleEmpleado.map((item) => {
      const fecha = new Date(item.fecha);
      const fechaFormateada = fecha.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      const entrada = item.hora_entrada_horario || "-";
      const salida = item.salida
        ? new Date(item.salida).toLocaleTimeString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
        : "-";

      let minutosExtras = 0;
      if (item.horas) {
        minutosExtras = Number(item.horas);
      } else if (item.minutos_trabajados) {
        minutosExtras = Number(item.minutos_trabajados - item.minutos_horario);
      }

      const horas = Math.floor(minutosExtras / 60);
      const minutos = minutosExtras % 60;
      const horasExtrasTexto = `${horas}:${minutos}H`;

      return {
        fecha: fechaFormateada,
        entrada,
        salida,
        horas_extras: horasExtrasTexto,
        minutos_extras: minutosExtras,
        valor_extras: item.descripcion_horas_extras || 0,
      };
    }),
  };

  setResumenHorasExtras(resumen);
  setModalHorasExtras(true);
};


  const handlePrintIPS = () => {
    if (!filteredData || filteredData.length === 0) return;
  
    const printWindow = window.open('', '_blank');
    const formattedStart = startDate.format('DD/MM/YYYY');
    const formattedEnd = endDate.format('DD/MM/YYYY');
    const periodText = `PERIODO DE PAGO: ${formattedStart} AL ${formattedEnd}`;
    const defaultLogos = {
      primary: `${window.location.origin}/assets/dracenaC.png`,
      secondary: `${window.location.origin}/assets/dracena2.png`,
    };
    const coinvertirLogos = {
      primary: `${window.location.origin}/assets/coinvertirlogo.png`,
      secondary: `${window.location.origin}/assets/coinvertirlogo.png`,
    };
    const VetroParLogos = {
      primary: `${window.location.origin}/assets/vetropar.png`,
      secondary: `${window.location.origin}/assets/vetropar.png`,
    };
    const SalamanderLogos = {
      primary: `${window.location.origin}/assets/Salamander.png`,
      secondary: `${window.location.origin}/assets/Salamander.png`,
    };
    const resolveLogos = (companyCode) => (companyCode === 5 ? coinvertirLogos : companyCode === 8 ? VetroParLogos : companyCode === 6 ? SalamanderLogos : defaultLogos);
    const formatted = (n) => parseFloat(n || 0).toLocaleString('es-ES'); 
  
    let html = `
      <html>
      <head>
        <title>Comprobante de Liquidación IPS</title>
        <style>
          @page {
            size: A4;
            margin: 10mm;
          }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
          }
          .invoice {
            border: 1px solid #000;
            padding: 12px;
            box-sizing: border-box;
            page-break-inside: avoid;
            border-bottom: 2px dashed #999;
            break-inside: avoid;
          }
          .invoice + .invoice {
            margin-top: 20px;
          }
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2px;
          }
          .header img {
            height: 50px;
          }
          .center-title {
            text-align: center;
            font-weight: bold;
            font-size: 14pt;
            margin-top: -10px;
          }
          .sub-title {
            text-align: center;
            font-size: 11pt;
            margin-bottom: 10px;
          }
          .info {
            font-size: 11pt;
            margin-bottom: 10px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 10pt;
            margin-top: 5px;
          }
          th, td {
            border: 1px solid #000;
            padding: 5px;
            text-align: center;
          }
          .firma {
            margin-top: 25px;
            text-align: left;
            font-size: 10pt;
          }
        </style>
      </head>
      <body>
    `;
  
    for (let i = 0; i < filteredData.length; i++) {
      const item = filteredData[i];
  
      const salario = parseFloat(item.salario || 0);
      const nocturno = parseFloat(item.nocturno || 0);
      const overtime = parseFloat(item.overtime_work_price || 0);
      const bonoFamiliar = parseFloat(item.bono_familiar || 0);
      const bonoProd = parseFloat(item.bono_produccion || 0);
      const ips = parseFloat(item.ips || 0);
      const adelanto = parseFloat(item.adelanto_deduction || 0);
      const descuento = parseFloat(item.descuento || 0);
      const total = parseFloat(item.total || 0);
      const daysWorked = item.dias_trabajados;
  
      const companyCode = Number(item.cod_empresa) || 1;
      const { primary: primaryLogo, secondary: secondaryLogo } = resolveLogos(companyCode);
      const employerName = item.empresa || (companyCode === 5 ? "COINVERTIR S.A." : "GRUPO DRACENA S.A.");
  
      html += `<div class="invoice-pair">`;
  

        html += `
          <div class="invoice">
            <div class="header">
              <img src="${primaryLogo}" alt="Company Logo" />
              <img src="${secondaryLogo || primaryLogo}" alt="Company Logo" class="logo" />
            </div>
            <div class="center-title">LIQUIDACIÓN DE SALARIO</div>
            <div class="sub-title">(Conforme al Art. 229 del Código del Trabajo)</div>
  
            <div class="info"><strong>EMPLEADOR:</strong> ${employerName}</div>
            <div class="info"><strong>NOMBRES Y APELLIDOS DEL TRABAJADOR:</strong> ${item.nombre}</div>
            <div class="info"><strong>${periodText}</strong></div>
  
            <table>
              <thead>
                <tr>
                  <th>Días Trab.</th>
                  <th>Grupo</th>
                  <th>Salario</th>
                  <th>Horas Extras</th>
                  <th>Bono Familiar</th>
                  <th>Bono Producción</th>
                  <th>Nocturno</th>
                  <th>I.P.S.</th>
                  <th>Adelanto</th>
                  <th>Descuento</th>
                  <th>Saldo a Cobrar</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${formatted(daysWorked)}</td>
                  <td>${item.grupo}</td>
                  <td>${formatted(salario)}</td>
                  <td>${formatted(overtime)}</td>
                  <td>${formatted(bonoFamiliar)}</td>
                  <td>${formatted(bonoProd)}</td>
                  <td>${formatted(nocturno)}</td>
                  <td>${formatted(ips)}</td>
                  <td>${formatted(adelanto)}</td>
                  <td>${formatted(descuento)}</td>
                  <td>${formatted(total)}</td>
                </tr>
              </tbody>
            </table>`

            // Obtener descuentos detallados para el empleado
const descuentosMarcaciones = marcacionesData.filter(m => {
  if (m.id_usuario !== item.id_usuario) return false;
  if (Number(m.descuento) <= 0) return false;

  const fechaMarcacion = dayjs(m.entrada || m.Fecha); // usa el campo correcto
  return  fechaMarcacion.isSameOrAfter(startDate, "day") &&
          fechaMarcacion.isSameOrBefore(endDate, "day");
});

const permisosPorHora = faltasData.filter(f => {
  if (f.id_usuario !== item.id_usuario) return false;
  if (f.tipo !== "PERMISO_POR_HORA") return false;

  const fechaPermiso = dayjs(f.hora_inicio); // convierte ISO a dayjs
  return fechaPermiso.isSameOrAfter(startDate, "day") &&
        fechaPermiso.isSameOrBefore(endDate, "day");
});

const descontar = faltasData.filter(f => {
  if (f.id_usuario !== item.id_usuario) return false;
  if (f.tipo !== "DESCONTAR") return false;

  const fechaInicio = dayjs(f.fecha_inicio);
  const fechaFin = dayjs(f.fecha_fin);

  return fechaInicio.isSameOrAfter(startDate, "day") &&
      fechaFin.isSameOrBefore(endDate, "day");
});


const horasExtras = marcacionesData.filter(m => {
  if (m.id_usuario !== item.id_usuario) return false;
  if (m.id_horas_extras === null || Number(m.id_horas_extras) === 0) return false;
  if (Number(m.aprobación_horas_extras) !== 1) return false; // solo aprobadas

  const fechaHE = dayjs(m.Fecha || m.entrada);
  return fechaHE.isSameOrAfter(startDate, "day") &&
          fechaHE.isSameOrBefore(endDate, "day");
});




const totalDescuentoMarcaciones = descuentosMarcaciones.reduce((acc, m) => acc + Number(m.descuento || 0), 0);
const totalDescuentoPermisos = permisosPorHora.reduce((acc, p) => acc + Number(p.descuento || 0), 0);
const totalDescuentos = totalDescuentoMarcaciones + totalDescuentoPermisos;
const totalDescuentosOtros = descontar.reduce(
  (acc, d) => acc + (Number(d.descuento) || 0), 0
);

<div style="height:20px;"></div>

// Tabla de detalle de descuentos
// Tabla de llegadas tardías
if (descuentosMarcaciones.length > 0) {
  html += `
    <h4>Descuentos por Llegadas Tardías</h4>
    <table>
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Hora Entrada</th>
          <th>Motivo</th>
          <th>Monto</th>
        </tr>
      </thead>
      <tbody>
  `;

  descuentosMarcaciones.forEach(m => {
    const fecha = new Date(m.entrada).toLocaleDateString("es-ES");
    const hora = new Date(m.entrada).toLocaleTimeString("es-ES");

    html += `
      <tr>
        <td>${fecha}</td>
        <td>${hora}</td>
        <td>Llegada tardía</td>
        <td>${formatted(m.descuento)} Gs.</td>
      </tr>
    `;
  });

  html += `
      <tr>
        <td colspan="3"><strong>Total Llegadas Tardías</strong></td>
        <td><strong>${formatted(totalDescuentoMarcaciones)} Gs.</strong></td>
      </tr>
      </tbody>
    </table>
  `;

}

// Tabla de permisos por hora
if (permisosPorHora.length > 0) {
  html += `
    <h4>Descuentos por Permisos por Hora</h4>
    <table>
      <thead>
        <tr>
          <th>Fecha del Permiso</th>
          <th>Hora Inicio</th>
          <th>Hora Fin</th>
          <th>Cantidad de Horas</th>
          <th>Observación</th>
          <th>Monto</th>
        </tr>
      </thead>
      <tbody>
  `;


  permisosPorHora.forEach(p => {
    const fechaPermiso = new Date(p.hora_inicio).toLocaleDateString("es-ES");
    const horaInicio = new Date(p.hora_inicio).toLocaleTimeString("es-ES", {hour: "2-digit", minute: "2-digit"});
    const horaFin = new Date(p.hora_fin).toLocaleTimeString("es-ES", {hour: "2-digit", minute: "2-digit"});

    html += `
      <tr>
        <td>${fechaPermiso}</td>
        <td>${horaInicio}</td>
        <td>${horaFin}</td>
        <td>${p.horas}</td>
        <td>${p.obs || "-"}</td>
        <td>${formatted(p.descuento)} Gs.</td>
      </tr>
    `;
  });

  html += `
      <tr>
        <td colspan="5"><strong>Total Permisos por Hora</strong></td>
        <td><strong>${formatted(totalDescuentoPermisos)} Gs.</strong></td>
      </tr>
      </tbody>
    </table>
  `;

}

if (descontar.length > 0) {
  html += `
    <h4>Otros Descuentos</h4>
    <table>
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Motivo de descuento</th>
          <th>Monto</th>
        </tr>
      </thead>
      <tbody>
  `;

  descontar.forEach(d => {
    const fechaDescuento = new Date(d.fecha_inicio).toLocaleDateString("es-ES");

    html += `
      <tr>
        <td>${fechaDescuento}</td>
        <td>${d.obs || "-"}</td>
        <td>${formatted(d.descuento)} Gs.</td>
      </tr>
    `;
  });

  html += `
      <tr>
        <td colspan="2"><strong>Total de Otros descuentos</strong></td>
        <td><strong>${formatted(totalDescuentosOtros)} Gs.</strong></td>
      </tr>
      </tbody>
    </table>
  `;
}

if (horasExtras.length > 0) {
  html += `
    <h4>Detalle de Horas Extras</h4>
    <table>
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Hora Entrada</th>
          <th>Hora Salida</th>
          <th>Monto</th>
        </tr>
      </thead>
      <tbody>
  `;

  horasExtras.forEach(h => {
    const fecha = new Date(h.Fecha).toLocaleDateString("es-ES");
    const horaEntrada = h.entrada ? new Date(h.entrada).toLocaleTimeString("es-ES", {hour: "2-digit", minute: "2-digit"}) : "-";
    const horaSalida = h.salida ? new Date(h.salida).toLocaleTimeString("es-ES", {hour: "2-digit", minute: "2-digit"}) : "-";

    html += `
      <tr>
        <td>${fecha}</td>
        <td>${horaEntrada}</td>
        <td>${horaSalida}</td>
        <td>${formatted(h.id_horas_extras)} Gs.</td>
      </tr>
    `;
  });

  const totalHorasExtras = horasExtras.reduce((acc, h) => acc + Number(h.id_horas_extras || 0), 0);

  html += `
      <tr>
        <td colspan="3"><strong>Total Horas Extras</strong></td>
        <td><strong>${formatted(totalHorasExtras)} Gs.</strong></td>
      </tr>
      </tbody>
    </table>
  `;
}

html += `
<div class="firma">Firma del Empleado</div>
</div> <!-- cierre del invoice -->
`;        


  
      html += `</div>`; 
    }
  
    html += `</body></html>`;
  
    printWindow.document.write(html);
    printWindow.document.close();
  
    const waitForImages = setInterval(() => {
      const imgs = printWindow.document.images;
      if (imgs.length === 0 || Array.from(imgs).every(img => img.complete)) {
        clearInterval(waitForImages);
        printWindow.focus();
        printWindow.print();
      }
    }, 100);
  };

  useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);

      const formattedStart = startDate.format('YYYY-MM-DD');
      const formattedEnd = endDate.format('YYYY-MM-DD');
      const mes = startDate.month() + 1;
      const año = startDate.year();
      
      const datosResumen = await getResumenView(formattedStart, formattedEnd);
      const datosUsuarios = await getDatosUserView(); 
      const datosMarcaciones = await getMarcacionesView(formattedStart, formattedEnd);
      const datosDelBanco = await getBancoPendiente();
      setDatosBanco(datosDelBanco);

      const datosFaltas = await getFaltas();
      setMarcacionesData(datosMarcaciones);
      setFaltasData(datosFaltas);


        // Filtrar solo permisos por hora del rango
        const permisosPorHora = datosFaltas.filter(f =>
          f.tipo === "PERMISO_POR_HORA" &&
          f.hora_inicio.slice(0, 10) >= formattedStart &&
          f.hora_inicio.slice(0, 10) <= formattedEnd
        );

        // Filtrar descuentos tipo "DESCONTAR"
        const descontar = datosFaltas.filter(f =>
          f.tipo === "DESCONTAR" &&
          f.fecha_inicio.slice(0, 10) >= formattedStart &&
          f.fecha_fin.slice(0, 10) <= formattedEnd
        );


      // Agrupar el descuento por empleado
      const descuentoPermisoPorEmpleado = {};
      permisosPorHora.forEach(p => {
        const monto = Number(p.descuento) || 0;
        descuentoPermisoPorEmpleado[p.id_usuario] =
          (descuentoPermisoPorEmpleado[p.id_usuario] || 0) + monto;
      });

      // Sumar descuentos tipo "DESCONTAR"
      descontar.forEach(d => {
        const monto = Number(d.descuento) || 0;
        descuentoPermisoPorEmpleado[d.id_usuario] =
          (descuentoPermisoPorEmpleado[d.id_usuario] || 0) + monto;
      });



      const marcacionesFiltradas = datosMarcaciones.filter(item => {
        const fecha = new Date(item.entrada).toISOString().slice(0, 10);
        const inicio = new Date(formattedStart).toISOString().slice(0, 10);
        const fin = new Date(formattedEnd).toISOString().slice(0, 10);
        return fecha >= inicio && fecha <= fin;
      });
      setMarcacionesFiltradas(marcacionesFiltradas);

      const adicionalesNocturnos = tablaPivote(marcacionesFiltradas, mes, año);

      const mappedData = datosResumen.filter(row => {
          const ingreso = dayjs(row.fecha_entrada).startOf("day");
          if (row.empresa === "OTROS") return false;
          const egreso = row.fecha_egreso ? dayjs(row.fecha_egreso) : null;
          const ingresoValido = ingreso.isSameOrBefore(endDate.endOf("day"));
          const egresoValido = !egreso || egreso.isSameOrAfter(startDate);
          return ingresoValido && egresoValido;
        }).map((row) => {
        const adicional = adicionalesNocturnos.find(a => a.id_empleado === row.id_empleado);

        const totalBanco = datosDelBanco
          .filter(b => b.id_empleado === row.id_empleado || b.id_usuario === row.id)
          .reduce((sum, b) => sum + Number(b.minutos || 0), 0);
        const descuentoPermiso = descuentoPermisoPorEmpleado[row.id] || 0;
        const nocturno = adicional ? Number(adicional.total) : 0;
         // 🔹 Buscar el usuario en getUserView
        const usuario = datosUsuarios.find(u => u.id === row.id);
        const horarioDescripcion = usuario ? usuario.horario_descripcion : "Sin horario";
        const salario = Number(row.salario_monto) || 0;
        const bonoFamiliar = Number(row.bono_familiar) || 0;
        const bonoProduccion = Number(row.bono_produccion) || 0;
        const adelanto = Number(row.adelanto_deduction) || 0;
        const descuentoTotal = (Number(row.total_descuento) + descuentoPermiso) || 0;
        const salarioBase = Number(row.salario_externo) || 0;
        const salarioIPS = Number(row.salario_ips) || 0;
        const rowCodEmpresa = Number(row.cod_empresa);

        const resolvedCompanyCode = !Number.isNaN(rowCodEmpresa) && rowCodEmpresa > 0 ? rowCodEmpresa : 1;
        const resolvedEmpresa = row.empresa || row.empresa_descripcion || (resolvedCompanyCode === 5 ? "COINVERTIR S.A." : "GRUPO DRACENA S.A.");
          // 🔹 Calcular días trabajados con la nueva función
          const diasTrabajados = calcularDiasTrabajados({
            fechaIngreso: row.fecha_entrada,   // aquí usás la fecha de ingreso real
            fechaEgreso: row.fecha_egreso,
            startDate,
            endDate,
            faltas: datosFaltas,           // pasás el array completo de faltas
            id_usuario: row.id,
          });

          // 🔍 Detectar reposo especial dentro del período
          const tieneReposoEspecial = datosFaltas.some(f =>
            f.id_usuario === row.id &&
            f.tipo === "PERMISO_POR_DIA" &&
            f.obs?.toUpperCase().includes("REPOSO POR IPS") &&
            f.fecha_inicio.slice(0, 10) <= formattedEnd &&
            f.fecha_fin.slice(0, 10) >= formattedStart
          );


          const mes = startDate.month() + 1;
        const anio = startDate.year();

          let diasMes = 30;
          let diasFebrero = 0;

          // Si es febrero
          if (mes === 2) {
            diasFebrero = dayjs(`${anio}-02-01`).daysInMonth(); // 28 o 29
          }

          // 🧠 Lógica correcta de liquidación
          let salarioCalculado;

          if (
            mes === 2 &&
            diasTrabajados >= diasFebrero // trabajó todo febrero
          ) {
            // sueldo completo
            salarioCalculado = salarioBase;
          } else {
            // proporcional normal
            salarioCalculado = (salarioBase * diasTrabajados) / 30;
          }

          // proporcional IPS
          let salarioIPSCalculado;
          if (mes === 2 && diasTrabajados >= diasFebrero) {
            salarioIPSCalculado = salarioIPS;
          } else {
            salarioIPSCalculado = (salarioIPS * diasTrabajados) / 30;
          }


          
           // 🔹 IPS correcto (salario proporcional + nocturno)
          // Empresas que declaran horas extras en IPS (aplica desde abril)
          const empresasConOvertimeIPS = [6]; // ← poné acá los cod_empresa que correspondan
          const mesActual = startDate.month() + 1;
          const incluyeOvertimeEnIPS =
            empresasConOvertimeIPS.includes(resolvedCompanyCode) && mesActual >= 4;
                  
          const overtimeParaIPS = incluyeOvertimeEnIPS
            ? Number(row.overtime_work_price || 0)
            : 0;
                  
          const ips = (salarioIPSCalculado + nocturno + overtimeParaIPS) * 0.09;

          // 💰 Diferencia salarial (externo - IPS)
          const diferenciaSalarial =
            salarioBase > salarioIPS
              ? salarioBase - salarioIPS
              : 0;
              

          let totalAdicionalCalculado =
            (salarioCalculado - salarioIPSCalculado) +
            bonoProduccion +
            Number(row.overtime_work_price || 0);

          // 🧠 Caso especial: reposo con pago de diferencia
          if (diasTrabajados === 0 && tieneReposoEspecial) {
            totalAdicionalCalculado = diferenciaSalarial;
          }



          // 🔥 Calcular TOTAL REAL
          const total =
            salarioCalculado +
            nocturno +
            bonoFamiliar +
            bonoProduccion +
            Number(row.overtime_work_price || 0)
            - descuentoTotal
            - adelanto
            - ips;

            // 🧮 Calcular total banco
            let totalBancoCalculado =
              salarioIPSCalculado +
              nocturno +
              bonoFamiliar -
              ips -
              adelanto;

            // 🧠 Ajuste si queda negativo
            let totalAdicionalFinal = totalAdicionalCalculado;
            let totalBancoFinal = totalBancoCalculado;

            if (totalBancoFinal < 0) {
  totalAdicionalFinal += totalBancoFinal; // esto resta en realidad
  totalBancoFinal = 0;
}
                    
            if (descuentoTotal > 0) {
              if (totalAdicionalFinal >= descuentoTotal) {
                // ✅ El adicional cubre todo el descuento
                totalAdicionalFinal -= descuentoTotal;
              } else {
                // ⚠️ El adicional no alcanza
                const restante = descuentoTotal - totalAdicionalFinal;
                totalAdicionalFinal = 0;
                totalBancoFinal -= restante;
              }
            }
            
            // Evitar banco negativo
            if (totalBancoFinal < 0) {
              totalBancoFinal = 0;
            }


      
        return {
          id_usuario: row.id,
          Id_empleado: row.id_empleado,
          nombre: `${row.firstname} ${row.lastname}`,
          grupo: row.grupo_descripcion || "Desconocido",
          horas: row.horas || "0:00",
          empresa: row.empresa,
          dias_trabajados: diasTrabajados,
          salario_base: Number(row.salario_externo) || 0,
          salario: Math.round(salarioCalculado),
          horario_descripcion: horarioDescripcion,
          salario_ips: Math.round(salarioIPSCalculado),
          salario_por_dia: Number(row.salario_por_dia) || 0,
          nocturno: adicional ? adicional.total : 0,
          descuento: (Number(row.total_descuento)+descuentoPermiso) || 0,
          adelanto_deduction: Number(row.adelanto_deduction) || 0,
          total: Number(row.total_pay) || 0,
          ips: Math.round(ips),
          total: Math.round(total),
          overtime_work_price: Number(row.overtime_work_price) || 0,
          bono_familiar: Number(row.bono_familiar) || 0,
          bono_produccion: Number(row.bono_produccion) || 0,
          total_banco: Math.round(totalBancoFinal),
          total_adicional: Math.round(totalAdicionalFinal),
          cod_empresa: resolvedCompanyCode,
          empresa: resolvedEmpresa,
          banco: totalBanco,
          cod_empresa: resolvedCompanyCode,
          empresa: resolvedEmpresa,
          fecha_egreso: row.fecha_egreso,
        };
      })
      .filter(row => row.dias_trabajados >= 0);

      setOriginalData(mappedData);
      const empresasUnicas = [
        "GENERAL",
        ...new Set(
          mappedData
            .map(r => r.empresa)
            .filter(e => e && e.trim() !== "" && e !== "OTRO")
        ),
      ];

setEmpresas(empresasUnicas);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, [startDate, endDate]);

  useEffect(() => {
    let resultado = [...originalData];

    // 🔹 Filtro por empresa
    if (empresaActiva !== "GENERAL") {
      resultado = resultado.filter(
        item => item.empresa === empresaActiva
      );
    }

    // Filtro por grupo
    if (grupoActivo !== "TODOS") {
      resultado = resultado.filter(item => item.grupo === grupoActivo);
    }

      if (grupoActivo === "FABRICA_VIDRIO") {
        if (turnoActivo !== "TODOS") {
          resultado = resultado.filter(
            item => item.horario_descripcion === turnoActivo
          );
        }
      }




    // 🔹 Filtro por texto
    if (searchValue.trim() !== "") {
      const value = searchValue.toLowerCase();

      resultado = resultado.filter(item =>
        (item.nombre ?? "").toLowerCase().includes(value) ||
        (item.grupo ?? "").toLowerCase().includes(value)
      );
    }

    setFilteredData(resultado);
  }, [searchValue, empresaActiva, originalData, grupoActivo, turnoActivo]);

  useEffect(() => {
    if (empresaActiva && empresaActiva !== "GENERAL") {
      const gruposUnicos = [
        "TODOS",
        ...new Set(
          originalData
            .filter(item => item.empresa === empresaActiva)
            .map(item => item.grupo)
            .filter(g => g && g.trim() !== "")
        ),
      ];
      setGrupos(gruposUnicos);
    } else {
      setGrupos([]);
    }
  }, [empresaActiva, originalData]);

  useEffect(() => {
  if (grupoActivo === "FABRICA_VIDRIO") {
    const turnosUnicos = [
      "TODOS",
      ...new Set(
        originalData
          .filter(item => item.grupo === "FABRICA_VIDRIO")
          .map(item => item.horario_descripcion)
          .filter(t => t && t.trim() !== "")
      ),
    ];
    setTurnos(turnosUnicos);
  } else {
    setTurnos([]);
  }

}, [grupoActivo, originalData]);
  



  const convertToMinutes = (time) => {
    if (!time) return 0;
  
    const trimmed = time.toString().trim();
  
    if (/^\d+$/.test(trimmed)) {
      return Number(trimmed);
    }
  
    const [hours, minutes] = trimmed.split(":").map((num) => parseInt(num, 10) || 0);
    return hours * 60 + minutes;
  };

  const convertToTimeFormat = (minutes) => {
    if (isNaN(minutes) || minutes < 0) {
      return "0:00";
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const paddedMins = mins.toString().padStart(2, "0");
    return `${hours}:${paddedMins}`;
  };

  const formatHoursHHmm = (hoursVal) => {
    const v = Number(hoursVal || 0);
    const h = Math.floor(v);
    const m = Math.round((v - h) * 60);
    return `${h}:${m.toString().padStart(2, "0")}`;
  };

const handleExport = async () => {
  const workbook = new ExcelJS.Workbook();
  const data = originalData.filter(r => !r.fecha_egreso);
  const resumenDesdeHojas = {};

  const empresasUnicas = [...new Set(data.map(r => r.empresa))];

  for (const empresa of empresasUnicas) {
    const dataEmpresa = data.filter(r => r.empresa === empresa);
    const gruposUnicos = [...new Set(dataEmpresa.map(r => r.grupo))];

    for (const grupo of gruposUnicos) {
      const dataGrupo = dataEmpresa.filter(r => r.grupo === grupo);

      const worksheet = workbook.addWorksheet(`${empresa}_${grupo}`);

      worksheet.columns = [
        { header: 'Nombre y Apellido', key: 'nombre', width: 25 },
        { header: 'Días Trabajados', key: 'dias_trabajados', width: 15 },
        { header: 'Salario Base', key: 'salario_base', width: 15 },
        { header: 'Salario', key: 'salario', width: 15 },
        { header: 'Salario IPS', key: 'salario_ips', width: 15 },
        { header: 'Nocturno', key: 'nocturno', width: 15 },
        { header: 'Bono Familiar', key: 'bono_familiar', width: 15 },
        { header: 'Bono Producción', key: 'bono_produccion', width: 15 },
        { header: 'Descuento', key: 'descuento', width: 15 },
        { header: 'Adelanto', key: 'adelanto_deduction', width: 15 },
        { header: 'Hora Extra', key: 'overtime_work_price', width: 15 },
        { header: 'IPS', key: 'ips', width: 15 },
        { header: 'Total a Pagar', key: 'total', width: 20 },
        { header: 'Total Banco', key: 'total_banco', width: 20 },
        { header: 'Total Adicional', key: 'total_adicional', width: 20 },
      ];

      worksheet.addRows(dataGrupo);

      const totals = {
        nombre: "TOTAL",
        dias_trabajados: "",
        salario_base: "",
        salario: dataGrupo.reduce((sum, r) => sum + (Number(r.salario) || 0), 0),
        salario_ips: dataGrupo.reduce((sum, r) => sum + (Number(r.salario_ips) || 0), 0),
        nocturno: dataGrupo.reduce((sum, r) => sum + (Number(r.nocturno) || 0), 0),
        bono_familiar: dataGrupo.reduce((sum, r) => sum + (Number(r.bono_familiar) || 0), 0),
        bono_produccion: dataGrupo.reduce((sum, r) => sum + (Number(r.bono_produccion) || 0), 0),
        descuento: dataGrupo.reduce((sum, r) => sum + (Number(r.descuento) || 0), 0),
        adelanto_deduction: dataGrupo.reduce((sum, r) => sum + (Number(r.adelanto_deduction) || 0), 0),
        overtime_work_price: dataGrupo.reduce((sum, r) => sum + (Number(r.overtime_work_price) || 0), 0),
        ips: dataGrupo.reduce((sum, r) => sum + (Number(r.ips) || 0), 0),
        total: dataGrupo.reduce((sum, r) => sum + (Number(r.total) || 0), 0),
        total_banco: dataGrupo.reduce((sum, r) => sum + (Number(r.total_banco) || 0), 0),
        total_adicional: dataGrupo.reduce((sum, r) => sum + (Number(r.total_adicional) || 0), 0),
      };

      if (!resumenDesdeHojas[empresa]) {
        resumenDesdeHojas[empresa] = {
          empresa,
          total: 0,
          total_banco: 0,
          total_adicional: 0,
        };
      }

      resumenDesdeHojas[empresa].total += Number(totals.total) || 0;
      resumenDesdeHojas[empresa].total_banco += Number(totals.total_banco) || 0;
      resumenDesdeHojas[empresa].total_adicional += Number(totals.total_adicional) || 0;

      worksheet.addRow(totals);

      // 🔹 Estilos cabecera
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '143f04' } };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      // 🔹 Estilos totales
      const lastRow = worksheet.lastRow;
      lastRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9ead3' } };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      // 🔹 Bordes generales
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      });
    }
  }

  // ===============================
  // 🔹 HOJA RESUMEN POR EMPRESA (todos los funcionarios)
  // ===============================
  for (const empresa of empresasUnicas) {
    const dataEmpresa = data.filter(r => r.empresa === empresa);

    const resumenEmpresaSheet = workbook.addWorksheet(`RESUMEN_${empresa}`);

    resumenEmpresaSheet.columns = [
      { header: 'Nombre y Apellido', key: 'nombre', width: 25 },
      { header: 'Grupo', key: 'grupo', width: 15 },
      { header: 'Días Trabajados', key: 'dias_trabajados', width: 15 },
      { header: 'Salario Base', key: 'salario_base', width: 15 },
      { header: 'Salario', key: 'salario', width: 15 },
      { header: 'Salario IPS', key: 'salario_ips', width: 15 },
      { header: 'Nocturno', key: 'nocturno', width: 15 },
      { header: 'Bono Familiar', key: 'bono_familiar', width: 15 },
      { header: 'Bono Producción', key: 'bono_produccion', width: 15 },
      { header: 'Descuento', key: 'descuento', width: 15 },
      { header: 'Adelanto', key: 'adelanto_deduction', width: 15 },
      { header: 'Hora Extra', key: 'overtime_work_price', width: 15 },
      { header: 'IPS', key: 'ips', width: 15 },
      { header: 'Total a Pagar', key: 'total', width: 20 },
      { header: 'Total Banco', key: 'total_banco', width: 20 },
      { header: 'Total Adicional', key: 'total_adicional', width: 20 },
    ];

    resumenEmpresaSheet.addRows(dataEmpresa);

    const totalsEmpresa = {
      nombre: 'TOTAL',
      grupo: '',
      dias_trabajados: '',
      salario_base: '',
      salario: dataEmpresa.reduce((sum, r) => sum + (Number(r.salario) || 0), 0),
      salario_ips: dataEmpresa.reduce((sum, r) => sum + (Number(r.salario_ips) || 0), 0),
      nocturno: dataEmpresa.reduce((sum, r) => sum + (Number(r.nocturno) || 0), 0),
      bono_familiar: dataEmpresa.reduce((sum, r) => sum + (Number(r.bono_familiar) || 0), 0),
      bono_produccion: dataEmpresa.reduce((sum, r) => sum + (Number(r.bono_produccion) || 0), 0),
      descuento: dataEmpresa.reduce((sum, r) => sum + (Number(r.descuento) || 0), 0),
      adelanto_deduction: dataEmpresa.reduce((sum, r) => sum + (Number(r.adelanto_deduction) || 0), 0),
      overtime_work_price: dataEmpresa.reduce((sum, r) => sum + (Number(r.overtime_work_price) || 0), 0),
      ips: dataEmpresa.reduce((sum, r) => sum + (Number(r.ips) || 0), 0),
      total: dataEmpresa.reduce((sum, r) => sum + (Number(r.total) || 0), 0),
      total_banco: dataEmpresa.reduce((sum, r) => sum + (Number(r.total_banco) || 0), 0),
      total_adicional: dataEmpresa.reduce((sum, r) => sum + (Number(r.total_adicional) || 0), 0),
    };

    resumenEmpresaSheet.addRow(totalsEmpresa);

    // 🔹 Estilo cabecera
    resumenEmpresaSheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '143f04' } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // 🔹 Estilo fila total
    const lastEmpresaRow = resumenEmpresaSheet.lastRow;
    lastEmpresaRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'd9ead3' } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // 🔹 Bordes generales
    resumenEmpresaSheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });
  }

  // ===============================
  // 🔹 HOJA RESUMEN GENERAL
  // ===============================
  const resumenSheet = workbook.addWorksheet('RESUMEN_GENERAL');

  resumenSheet.columns = [
    { header: 'Empresa', key: 'empresa', width: 25 },
    { header: 'Salario', key: 'salario', width: 15 },
    { header: 'IPS', key: 'ips', width: 15 },
    { header: 'Total Banco', key: 'total_banco', width: 18 },
    { header: 'Total Adicional', key: 'total_adicional', width: 18 },
    { header: 'TOTAL EMPRESA', key: 'total_empresa', width: 20 },
  ];

  const resumenPorEmpresa = Object.values(resumenDesdeHojas).map(r => ({
    empresa: r.empresa,
    salario: '',
    ips: '',
    total_banco: r.total_banco,
    total_adicional: r.total_adicional,
    total_empresa: r.total,
  }));

  resumenSheet.addRows(resumenPorEmpresa);

  const totalGeneral = {
    empresa: 'TOTAL GENERAL',
    salario: '',
    ips: '',
    total_banco: resumenPorEmpresa.reduce((s, r) => s + r.total_banco, 0),
    total_adicional: resumenPorEmpresa.reduce((s, r) => s + r.total_adicional, 0),
    total_empresa: resumenPorEmpresa.reduce((s, r) => s + r.total_empresa, 0),
  };

  resumenSheet.addRow(totalGeneral);

  // 🔹 Estilo cabecera
  resumenSheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '143f04' } };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });

  // 🔹 Estilo fila TOTAL GENERAL
  const lastResumenRow = resumenSheet.lastRow;
  lastResumenRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'fff2cc' } };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });

  // 🔹 Bordes generales
  resumenSheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
  });

  // ===============================
  // 🔹 GUARDAR ARCHIVO
  // ===============================
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'Planilla_de_Salarios.xlsx';
  link.click();
};

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" p={0}>
        <Header
          title="Resumen para Pagos"
          subtitle="Resumen de Asistencia para Pagos"
        />
        <Box display="flex" alignItems="center">
        
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            marginRight: "2%",
            marginLeft: "2%",
            alignItems: "center",
          }}
        >
          <Button
            sx={{
              background: "#143f04",
              height: "3rem!important",
              color: "white",
              borderRadius: "8px",
              "&:hover": { background: "#36a60f" },
            }}
            onClick={handleExport}
            variant="contained"
            color="primary"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
              alt="Excel Icon"
              style={{ width: 24, height: 24, marginRight: 8 }}
            />
            Exportar
          </Button>

          <Button
            sx={{
              background: "#143f04",
              height: "3rem!important",
              color: "white",
              borderRadius: "8px",
              "&:hover": { background: "#36a60f" },
            }}
            onClick={handlePrintIPS}
            variant="contained"
            color="primary"
          >
            🖨 Imprimir Recibo
          </Button>
        </Box>

          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            height={"50%"}
            width={"100%"}
            ml={1}
          >

            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Buscar"
              value={searchValue}
              onChange={handleSearchChange}
            />
            <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton>
          </Box>
          
        </Box>
      </Box>

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          overflowY: 'auto',
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: colors.greenAccent[300] },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "-1%",
            marginRight: "5px",
          }}
        >
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label="Fecha de Inicio"
                  value={startDate}
                  onChange={(newValue) => {
                    const newDate = dayjs(newValue);
                  
                    if (endDate && newDate.isAfter(endDate)) {
                      setDateError("La fecha de inicio no puede ser posterior a la fecha de fin");
                    } else {
                      setDateError("");
                      setStartDate(newDate);
                    }
                  }}
                  format="DD/MM/YYYY"
                />
                <DatePicker
                  label="Fecha de Fin"
                  value={endDate}
                  onChange={(newValue) => {
                    const newDate = dayjs(newValue);
                  
                    if (startDate && newDate.isBefore(startDate)) {
                      setDateError("La fecha de fin no puede ser anterior a la fecha de inicio");
                    } else {
                      setDateError("");
                      setEndDate(newDate);
                    }
                  }}
                  format="DD/MM/YYYY"
                />
              </DemoContainer>
              {dateError && (
                <Box mt={1} color="error.main" fontSize="0.85rem">
                  {dateError}
                </Box>
              )}
            </LocalizationProvider>
          </Box>
        </Box>
        <Box display="flex" gap={2} mb={2} flexWrap="wrap">
          {/* 🔹 Mostrar empresas SOLO si no hay empresa seleccionada */}
          {empresaActiva === "GENERAL" &&
            empresas.map((empresa) => (
              <Button
                key={empresa}
                onClick={() => setEmpresaActiva(empresa)}
                variant={empresaActiva === empresa ? "contained" : "outlined"}
                sx={{
                  borderRadius: "10px",
                  padding: "10px 25px",
                  fontSize: "1rem",
                  backgroundColor:
                    empresaActiva === empresa ? "rgb(206, 220, 0)" : "transparent",
                  color: empresaActiva === empresa ? "black" : "white",
                  "&:hover": {
                    backgroundColor: "rgb(206, 220, 0)",
                    color: "black",
                  },
                }}
              >
                {empresa}
              </Button>
            ))}

          {/* 🔹 Mostrar grupos SOLO si ya se eligió una empresa y NO es FABRICA_VIDRIO */}
          {empresaActiva !== "GENERAL" && grupoActivo !== "FABRICA_VIDRIO" && grupos.length > 0 &&
            grupos.map((grupo) => (
              <Button
                key={grupo}
                onClick={() => setGrupoActivo(grupo)}
                variant={grupoActivo === grupo ? "contained" : "outlined"}
                sx={{
                  borderRadius: "10px",
                  padding: "10px 25px",
                  fontSize: "1rem",
                  backgroundColor:
                    grupoActivo === grupo ? "rgb(206, 220, 0)" : "transparent",
                  color: grupoActivo === grupo ? "black" : "white",
                  "&:hover": {
                    backgroundColor: "rgb(206, 220, 0)",
                    color: "black",
                  },
                }}
              >
                {grupo}
              </Button>
            ))}

          {/* 🔹 Botón para volver atrás a Empresas */}
          {empresaActiva !== "GENERAL" && grupoActivo !== "FABRICA_VIDRIO" && (
            <Button
              onClick={() => {
                setEmpresaActiva("GENERAL");
                setGrupoActivo("TODOS");
              }}
              variant="outlined"
              sx={{
                borderRadius: "10px",
                padding: "10px 25px",
                fontSize: "1rem",
                backgroundColor: "transparent",
                color: "white",
                "&:hover": {
                  backgroundColor: "red",
                  color: "black",
                },
              }}
            >
              <ArrowBackIcon />
            </Button>
          )}

          {/* 🔹 Mostrar turnos SOLO si el grupo es FABRICA_VIDRIO */}
          {grupoActivo === "FABRICA_VIDRIO" && turnos.length > 0 &&
            turnos.map((turno) => (
              <Button
                key={turno}
                onClick={() => setTurnoActivo(turno)}
                variant={turnoActivo === turno ? "contained" : "outlined"}
                sx={{
                  borderRadius: "10px",
                  padding: "10px 25px",
                  fontSize: "1rem",
                  backgroundColor:
                    turnoActivo === turno ? "rgb(206, 220, 0)" : "transparent",
                  color: turnoActivo === turno ? "black" : "white",
                  "&:hover": {
                    backgroundColor: "rgb(206, 220, 0)",
                    color: "black",
                  },
                }}
              >
                {turno}
              </Button>
            ))}

          {/* 🔹 Botón para volver atrás a Grupos */}
          {grupoActivo === "FABRICA_VIDRIO" && (
            <Button
              onClick={() => {
                setGrupoActivo("TODOS");
                setTurnoActivo("TODOS");
              }}
              variant="outlined"
              sx={{
                borderRadius: "10px",
                padding: "10px 25px",
                fontSize: "1rem",
                backgroundColor: "transparent",
                color: "white",
                "&:hover": {
                  backgroundColor: "red",
                  color: "black",
                },
              }}
            >
              <ArrowBackIcon />
            </Button>
          )}
        </Box>
        <DataGrid
          loading={isLoading}
          rows={filteredData}
          columns={columns}
          getRowId={(row, index) =>
            `${row.id_usuario}-${row.Id}-${row.Id_empleado}-${index}`
          } 
          components={{ Toolbar: CustomToolbar }}
          selectionModel={selectedRowIds}
          disableMultipleSelection={false}
          pagination
          pageSize={100}
          rowsPerPageOptions={[100]}
          autoHeight={false}
        />
        
      </Box>

      <DescuentosModal
        open={openDescuentos}
        onClose={() => setOpenDescuentos(false)}
        funcionarioSeleccionado={funcionarioSeleccionado}
        descuentosSeleccionados={descuentosSeleccionados}
      />

      <ModalEditWors
        open={modalEditWorks}
        onClose={() => setModalEditWorks(false)}
        onSelectClient={selectedWorks}
      />

      <ModalHorasExtras
        open={modalHorasExtras}
        onClose={() => setModalHorasExtras(false)}
        
        resumen={resumenHorasExtras}
      />

      <ModalBancoHoras
        open={modalBancoHoras}
        onClose={() => setModalBancoHoras(false)}
        data={resumenBancoHoras}
      />


      <ModalCharge isLoading={isLoading} />
    </Box>
  );
};

export default Resumen;